import { render } from "./ProductosPorCategoria.vue?vue&type=template&id=133bdace"
import script from "./ProductosPorCategoria.js?vue&type=script&lang=js&external"
export * from "./ProductosPorCategoria.js?vue&type=script&lang=js&external"

import "./ProductosPorCategoria.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__